import React from 'react';
import img from "../../Images/404.jpg"

const NotFound = () => {
    return (
        <div>
            <img src={img} alt='' />
        </div>
    );
};

export default NotFound;